import React from 'react'
import { Link } from 'react-router'

export default class Header extends React.Component {
  render() {
    return (
      <header className={this.props.content.headerStyle}>
        <div className="center-header">
          <div className="page-container">
            <h1>{this.props.content.header.name}</h1>
            <h2>{this.props.content.header.title}</h2>
          </div>
        </div>
        <div className="side-header">
          <h1><Link to="/">{this.props.content.header.name}</Link></h1>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global/Header.js